<template>
	<div>
		<loading :active.sync="isLoading" :can-cancel="false" :color="'#e99a60'" :is-full-page="true"></loading>
		<NavBar :showMenu="true" />
		<main role="main">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<p>
							Olá,
							<strong>{{ usuario.nome }}.</strong>
						</p>
						<p>
							Obrigado por realizar seu cadastro como associado da Rede de Estudos Rurais.
						</p>
					</div>

					<div class="col-md-12" v-if="usuario.approved == 1">
						<div class="alert alert-info" role="alert">
							Você participou do
							<strong>IX Encontro da Rede de Estudos Rurais</strong>
							?
							<strong>
								<a href="https://redesrurais.org.br/encontro/certificados" target="_blank">Solicite o seu certificado.</a>
							</strong>
						</div>
					</div>

					<div class="col-md-12 pt-5" v-if="usuario.approved == 1">
						<h5>Anuidades</h5>
					</div>

					<div class="col-md-12" v-if="usuario.opcoes.length > 0 && usuario.approved == 1">
						<div class="alert alert-warning" role="alert">
							Você possui anuidades com pagamento não confirmado.
						</div>
					</div>

					<div class="col-md-12" v-if="!isLoading && usuario.opcoes.length == 0">
						<div class="alert alert-success" role="alert">
							As suas anuidades estão
							<strong>em dia.</strong>
						</div>
					</div>

					<div class="col-md-12" v-if="usuario.approved == 0">
						<div class="alert alert-warning" role="alert">
							A sua solicitação está
							<strong>em análise</strong>
							e em breve você receberá um e-mail informando da sua situação.
						</div>
					</div>
					<div class="col-md-12" v-if="usuario.approved == 1">
						<div class="card bg-light">
							<div class="card-body" v-for="(anuidade, index) in usuario.anuidade" :key="index">
								A sua anuidade de
								<strong>{{ anuidade.ano }}</strong>
								está
								<span class="badge" :class="anuidade.class">{{ anuidade.status | toUpperCase }}</span>
							</div>
						</div>

						<div class="card bg-light mt-3" v-if="usuario.promocoes.length > 0">
							<div class="card-body">
								<h6>
									Regularize suas anuidades utilizando nossos descontos promocionais:
								</h6>
								<div class="table-responsive pt-2">
									<table class="table table-sm">
										<thead>
											<tr>
												<th scope="col">OPÇÃO</th>
												<th scope="col">DESCRIÇÃO</th>
												<th scope="col">VALOR</th>
												<th scope="col"></th>
											</tr>
										</thead>
										<tbody v-for="opcao in usuario.promocoes" :key="opcao.id">
											<tr>
												<td class="align-middle">{{ opcao.opcao }}</td>
												<td class="align-middle">{{ opcao.descricao }}</td>
												<td class="align-middle">
													{{ opcao.valor | currency }}
												</td>
												<td class="align-middle">
													<button type="button" class="btn btn-success btn-sm" @click="pagar(opcao.id)">
														<i class="fas fa-wallet"></i>
														Pagar Anuidade
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<p class="mt-3">
									Ao clicar em
									<strong>'Pagar Anuidade'</strong>
									você será redirecionado para o sistema do PagSeguro, onde poderá realizar o pagamento por boleto ou
									cartão de crédito.
								</p>
							</div>
						</div>

						<div class="card bg-light mt-3" v-if="usuario.opcoes.length > 0">
							<div class="card-body">
								<h6>
									<span v-if="usuario.promocoes.length > 0">Outras opções</span>
									<span v-else>Opções</span>
									de pagamento individuais:
								</h6>
								<div class="table-responsive pt-2">
									<table class="table table-sm">
										<thead>
											<tr>
												<th scope="col">OPÇÃO</th>
												<th scope="col">DESCRIÇÃO</th>
												<th scope="col">VALOR</th>
												<th scope="col"></th>
											</tr>
										</thead>
										<tbody v-for="opcao in usuario.opcoes" :key="opcao.id">
											<tr>
												<td class="align-middle">{{ opcao.opcao }}</td>
												<td class="align-middle">{{ opcao.descricao }}</td>
												<td class="align-middle">
													{{ opcao.valor | currency }}
												</td>
												<td class="align-middle">
													<button type="button" class="btn btn-success btn-sm" @click="pagar(opcao.id)">
														<i class="fas fa-wallet"></i>
														Pagar Anuidade
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<p class="mt-3">
									Ao clicar em
									<strong>'Pagar Anuidade'</strong>
									você será redirecionado para o sistema do PagSeguro, onde poderá realizar o pagamento por boleto ou
									cartão de crédito.
								</p>
							</div>
						</div>

						<div class="card bg-light mt-3" v-if="usuario.antecipacoes.length > 0">
							<div class="card-body">
								<h6>
									Antecipe o pagamento de suas anuidades e ganhe desconto:
								</h6>
								<div class="table-responsive pt-2">
									<table class="table table-sm">
										<thead>
											<tr>
												<th scope="col">OPÇÃO</th>
												<th scope="col">DESCRIÇÃO</th>
												<th scope="col">VALOR</th>
												<th scope="col"></th>
											</tr>
										</thead>
										<tbody v-for="opcao in usuario.antecipacoes" :key="opcao.id">
											<tr>
												<td class="align-middle">{{ opcao.opcao }}</td>
												<td class="align-middle">{{ opcao.descricao }}</td>
												<td class="align-middle">
													{{ opcao.valor | currency }}
												</td>
												<td class="align-middle">
													<button type="button" class="btn btn-success btn-sm" @click="pagar(opcao.id)">
														<i class="fas fa-wallet"></i>
														Pagar Anuidade
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<p class="mt-3">
									Ao clicar em
									<strong>'Pagar Anuidade'</strong>
									você será redirecionado para o sistema do PagSeguro, onde poderá realizar o pagamento por boleto ou
									cartão de crédito.
								</p>
							</div>
						</div>

						<div class="pt-3 pb-3" v-if="usuario.pedidos.length > 0">
							<div class="card bg-light">
								<div class="card-body">
									<h6>Histórico de transações:</h6>
									<div class="table-responsive">
										<table class="table table-sm">
											<thead>
												<tr>
													<th scope="col">DATA</th>
													<th scope="col">DESCRIÇÃO</th>
													<th scope="col">VALOR</th>
													<th scope="col">SITUAÇÃO</th>
													<th scope="col">MENSAGEM</th>
													<th scope="col">RECIBO</th>
												</tr>
											</thead>
											<tbody v-for="pedido in usuario.pedidos" :key="pedido.id">
												<tr>
													<td class="align-middle">{{ pedido.created }}</td>
													<td class="align-middle">{{ pedido.descricao }}</td>
													<td class="align-middle">
														{{ pedido.valor | currency }}
													</td>
													<td class="align-middle" v-if="pedido.type == 'pagseguro'">
														<span
															class="badge"
															:class="{
																'badge-success': pedido.status_id == 3 || pedido.status_id == 4,
																'badge-warning': pedido.status_id == 1 || pedido.status_id == 2,
																'badge-danger': pedido.status_id > 4,
															}"
														>
															{{ pedido.status }}
														</span>
													</td>
													<td class="align-middle" v-if="pedido.type == 'mercadopago'">
														<span
															class="badge"
															:class="{
																'badge-success': pedido.status_id == 1,
																'badge-warning': pedido.status_id == 2 || pedido.status_id == 3,
																'badge-danger': pedido.status_id > 3,
															}"
														>
															{{ pedido.status }}
														</span>
													</td>
													<td class="align-middle">
														{{ pedido.message }}
													</td>
													<td class="align-middle">
														<button type="button" v-if="pedido.recibo" class="btn btn-info btn-sm" @click="recibo(pedido.recibo)">
															<i class="fa fa-file-pdf"></i>
															Baixar
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						<p class="text-center">
							Dúvidas sobre sua situação cadastral e sobre o pagamento de anuidades? Entre em contato pelo email
							<strong>financeiro@redesrurais.org.br</strong>
							.
						</p>
						<div id="button-checkout"></div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 text-center mt-5">
						<img
							src="https://imgmp.mlstatic.com/org-img/MLB/MP/BANNERS/tipo2_575X40.jpg?v=1"
							alt="Mercado Pago - Meios de pagamento"
							title="Mercado Pago - Meios de pagamento"
							class="img-fluid"
						/>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global';

const axios = require('axios');
/* eslint-disable */
export default {
	name: 'login',
	data: function() {
		return {
			isLoading: false,
			usuario: {
				nome: null,
				opcoes: [],
				anuidade: [],
			},
		};
	},
	components: {
		NavBar,
		Loading,
	},
	filters: {
		toUpperCase: function(value) {
			return value.toUpperCase();
		},
	},
	methods: {
		socio() {
			this.isLoading = true;
			axios
				.get(baseApiUrl + 'api/socios/socio?id=' + this.$auth.user().data.id)
				.then((response) => {
					this.isLoading = false;
					this.usuario = response.data;
				})
				.catch(() => {
					this.isLoading = false;
					this.$toasted.global.defaultError({
						mensagem: 'Não foi possível conectar ao servidor. Verifique a sua conexão e tente novamente.',
					});
				});
		},
		registrar(transactionCode, reference, opcao_id) {
			this.isLoading = true;
			var self = this;
			axios
				.post(baseApiUrl + 'api/pagamento/registrar', {
					opcao_id: opcao_id,
					reference: reference,
					socio_id: this.$auth.user().data.id,
					transaction_code: transactionCode,
				})
				.then(() => {
					self.$toasted.global.defaultSuccess({
						mensagem: 'Sua solicitação foi registrada com sucesso.',
					});
					self.socio();
				})
				.catch(() => {
					this.isLoading = false;
				});
		},
		pagar(opcao_id) {
			this.isLoading = true;
			var self = this;

			axios
				.post(baseApiUrl + 'api/pagamento/preference', {
					opcao: opcao_id,
					socio: this.$auth.user().data.id,
				})
				.then((response) => {
					const mercadopago = new MercadoPago('APP_USR-965a29ce-d3d7-46f2-884c-0a5a9ff7cf4a', {
						locale: 'pt-BR',
					});

					mercadopago.checkout({
						preference: {
							id: response.data,
						},
						autoOpen: true,
					});
				})
				.catch(() => {
					self.$toasted.global.defaultError({
						mensagem: 'Não foi possível realizar a requisição do pagamento. Tente novamente mais tarde.',
					});
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
		recibo(url) {
			window.open(url);
		},
	},
	mounted() {
		this.socio();
	},
};
</script>

<style scoped>
table {
	color: #686868;
	font-size: 0.9em;
	margin-bottom: 0;
}
</style>
